// @mui
import {
  Stack,
  Divider,
  Typography,
} from '@mui/material';
// next
import { useRouter } from 'next/router';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Avatar from '../../components/Avatar';
import Scrollbar from '../../components/Scrollbar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
// utils
import { fKrDateKST } from '../../utils/formatTime';
import { PATH_TODO } from '../../routes/paths';

export default function CompanyList() {
  const { company } = useCompany();

  return (
    <Scrollbar>
      <Stack
        divider={<Divider orientation="horizontal" flexItem />}
      >
        {company && company.map((row) => (
          <CompanyListItem
            key={row.id}
            row={row}
          />
        ))}
      </Stack>
    </Scrollbar>
  )
}

function CompanyListItem({
  row
}) {
  const {
    id,
    name,
    contract_end_date,
    is_active,
  } = row;

  const getStatusColor = (isActive) => {
    return isActive ? 'info' : 'default';
  };

  const router = useRouter();

  const pushToCompany = () => {
    router.push({pathname: PATH_TODO.detail, query: {c: id}})
  }

  return (
    <Stack
      direction="row" alignItems="center" justifyContent="space-between" sx={{ pl: 2, pr: 1, py: 2.5 }}
      onClick={pushToCompany}
    >
      <Stack spacing={1} sx={{ overflow: 'hidden' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/bji_${id%4 + 1}.png`}
            alt={name}
            sx={{
              width: 32,
              height: 32,
            }}
          />
          <Typography variant="subtitle2" noWrap sx={{ textOverflow: 'ellipsis' }}>
            {name}
          </Typography>
          <Label color={getStatusColor(is_active)} sx={{ minWidth: 50 }}>
            {is_active ? '계약 중' : '계약 종료'}
          </Label>
        </Stack>
        <Typography variant="body2">
          계약 종료일: {fKrDateKST(contract_end_date)}
        </Typography>
      </Stack>
      <Iconify sx={{ ml: 1, minWidth: 20, minHeight: 20, width: 20, height: 20, color: 'text.disabled' }} icon={'ic:baseline-chevron-right'} />
    </Stack>
  );
}
